enum Step {
  SELECT_RECORDS_TYPE,
  ADD_RECORDS,
}

export default Step;
